export default __webpack_public_path__ + "static/logo_EFTB-89c97231dbbf3a7f8097c86ceac756ca.png";